var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('login-form',{on:{"loginSucceeded":function($event){return _vm.onLoginSucceeded($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }